import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListTonesDtoImpl, ListTonesDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/listtonesdto';
import { ListTonesResponse } from 'src/com/sixdee/crbtportal/core/api/mytunes/listtones/listtonesresponse';
import { ListTonesRequestImpl } from 'src/com/sixdee/crbtportal/core/api/mytunes/listtones/listtonesrequest';
import { DeleteGroupDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/deletegroup/deletegroupdto';
import { DeleteGroupResponse } from 'src/com/sixdee/crbtportal/core/api/group/deletegroup/deletegroupresponse';
import { DeleteGroupRequestImpl } from 'src/com/sixdee/crbtportal/core/api/group/deletegroup/deletegrouprequest';

export interface ListGroupAPIModel extends APIModel
{
    getGroupList():void;
    deleteGroup(groupDto:GroupDto):void;
}

export class ListGroupAPIModelImpl extends APIModelImpl implements ListGroupAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }
    getGroupList():void
    {
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("2");
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            
            let groups = listTonesResponse.getListTonesResponseDtos().map((listTonesDtoData: ListTonesDto) =>
            
            {
                return listTonesDtoData.getGroupDto();
            });
            console.log("on Success of groups :",JSON.stringify(groups));
            console.log("feature :",listTonesResponse.getAPIFeature());
            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), groups);

         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    
    }

    deleteGroup(groupDto:GroupDto)
    {
       
        console.log("Inside Delete Group", groupDto.getGroupName());
       let deleteGroupDto = new DeleteGroupDtoImpl();
       deleteGroupDto.setGroupId(groupDto.getGroupId());
       deleteGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());
       deleteGroupDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
       this.getAPIProcesssorFactory().getGroupProcessorFactory()
       .getDeleteGroupAPIProcessor().success((deleteGroupResponse:DeleteGroupResponse)=>
       {
           this.getAPIModelHandler()
           .onSuccess(deleteGroupResponse.getAPIFeature(), deleteGroupResponse.getDescription(),
           groupDto);
       })
       .failure((deleteGroupResponse:DeleteGroupResponse)=>
       {
                this.getAPIModelHandler().onFailure(deleteGroupResponse.getAPIFeature(), deleteGroupResponse.getDescription(),
                undefined);
       })
       .execute(new DeleteGroupRequestImpl(deleteGroupDto));
       
    }

    // private getGroupDtos(): GroupDto[]
    // {
    //     let groupDto = new GroupDtoImpl();
    //     groupDto.setId("1");
    //     groupDto.setGroupName("helloooooo");

    //     let groupDto1 = new GroupDtoImpl();
    //     groupDto1.setId("1");
    //     groupDto1.setGroupName("helloooooo");
        
    //     return [groupDto, groupDto1];
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/listgroupapimodel.tsx